<template>
<DemoVideo
  title="Ruby SDK Demo"
  :demoVideo="videoFile"
  :navKeys="['demos', 'ruby_demo']"
  :key="viewKey"
/>
</template>

<script>
import whoosh_ruby from '../assets/whoosh_ruby.mp4'

import DemoVideo from '@/components/DemoVideo.vue'

export default {
  data () {
    return {
      videoFile: whoosh_ruby,
      viewKey: 1
    }
  },
  components: { DemoVideo },
  beforeRouteUpdate () {
    this.viewKey += 1
  }
}
</script>
